import { render, staticRenderFns } from "./Orderable.vue?vue&type=template&id=51811ede&scoped=true&"
import script from "./Orderable.vue?vue&type=script&lang=js&"
export * from "./Orderable.vue?vue&type=script&lang=js&"
import style0 from "./orderable.scss?vue&type=style&index=0&id=51811ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51811ede",
  null
  
)

export default component.exports